export default __webpack_public_path__ + "static/media/NSVideo.892fc144.jpeg";